import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  settings: [],
  loading: false,
  error: null,
  successMessage: null,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    // Fetch settings
    fetchSettings: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSettingsSuccess: (state, action) => {
      state.loading = false;
      state.settings = action.payload;
      state.error = null;
    },
    fetchSettingsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update settings
    updateSettings: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateSettingsSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    updateSettingsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update local setting value (for form state management)
    updateLocalSettingValue: (state, action) => {
      const { category, key, value } = action.payload;
      const categoryIndex = state.settings.findIndex((cat) => cat.category === category);
      if (categoryIndex !== -1) {
        const settingIndex = state.settings[categoryIndex].settings.findIndex(
          (setting) => setting.key === key
        );
        if (settingIndex !== -1) {
          state.settings[categoryIndex].settings[settingIndex].values = Array.isArray(value)
            ? value
            : [value];
        }
      }
    },

    // Clear messages
    clearError: (state) => {
      state.error = null;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
  },
});

export const {
  fetchSettings,
  fetchSettingsSuccess,
  fetchSettingsFailure,
  updateSettings,
  updateSettingsSuccess,
  updateSettingsFailure,
  updateLocalSettingValue,
  clearError,
  clearSuccessMessage,
} = settingsSlice.actions;

// Selectors
export const selectSettings = (state) => state.settings?.settings || [];
export const selectSettingsLoading = (state) => state.settings?.loading || false;
export const selectSettingsError = (state) => state.settings?.error;
export const selectSettingsSuccessMessage = (state) => state.settings?.successMessage;

export default settingsSlice.reducer;
